var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoatRoomPoi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3,
    fill: "#0000FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 20.9997V17.8602L26.073 16.7082C26.5811 16.426 27.0045 16.0131 27.2994 15.5123C27.5942 15.0114 27.7498 14.4409 27.75 13.8597C27.6912 12.914 27.2608 12.0299 26.5526 11.4004C25.8445 10.771 24.916 10.4471 23.97 10.4997C23.1171 10.4643 22.2786 10.7279 21.5994 11.245C20.9202 11.7621 20.4429 12.5001 20.25 13.3317",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 30.75H31.5C31.8978 30.75 32.2794 30.908 32.5607 31.1893C32.842 31.4706 33 31.8522 33 32.25V37.5H15V32.25C15 31.8522 15.158 31.4706 15.4393 31.1893C15.7206 30.908 16.1022 30.75 16.5 30.75Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0007 33H34.8592C35.4262 33.0024 35.9786 32.821 36.4339 32.483C36.8891 32.1451 37.2226 31.6687 37.3844 31.1253C37.5462 30.5819 37.5277 30.0007 37.3315 29.4688C37.1353 28.9368 36.7721 28.4827 36.2962 28.1745L26.2177 21.654C25.5571 21.2271 24.7872 21 24.0007 21C23.2141 21 22.4443 21.2271 21.7837 21.654L11.7052 28.1745C11.2293 28.4827 10.8661 28.9368 10.6699 29.4688C10.4737 30.0007 10.4551 30.5819 10.6169 31.1253C10.7788 31.6687 11.1123 32.1451 11.5675 32.483C12.0227 32.821 12.5752 33.0024 13.1422 33H15.0007",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoatRoomPoi);
export default __webpack_public_path__ + "static/media/coat-room-poi.cccc794d563739aef5f63d081870391d.svg";
export { ForwardRef as ReactComponent };